import React from 'react';
import { maxWidthContainer } from '@noths/polaris-client-ribbons-base';
import { Button } from '@noths/polaris-design-system-core-components';

import * as styles from './ProductListError.styles';

const DEFAULT_MESSAGE = 'There was a problem loading the products.';

interface ProductListErrorProps {
  message?: string;
}

export const ProductListError = ({ message = DEFAULT_MESSAGE }: ProductListErrorProps) => {
  return (
    <div css={[maxWidthContainer, styles.outer]}>
      <h3>Oops!</h3>
      <p>{message}</p>
      <Button
        compact
        onClick={() => {
          window.location.reload();
        }}
        secondary
        type="button"
      >
        Try reloading the page
      </Button>
    </div>
  );
};
